import * as React from 'react'
import PropTypes from 'prop-types'
import { compose } from 'recompose'
import { connect } from 'react-redux'

import ControlpanelDesktopMenu from './components/controlpanel-desktop-menu'
import ControlpanelMobileMenu from './components/controlpanel-mobile-menu'
import { getMyEventplannerRequests } from '../../stores/gig-request-eventplanner/reducer'

const mapStateToProps = state => ({
  eventplannerGigRequest: getMyEventplannerRequests(state),
})

const mapDispatchToProps = dispatch => ({})

const HeaderMenuControlpanelContainer = React.memo(({ eventplannerGigRequest }) => (
  <>
    <ControlpanelMobileMenu
      eventplannerRequestCount={
        eventplannerGigRequest && eventplannerGigRequest.length > 0
          ? eventplannerGigRequest.length
          : 0
      }
    />
    <ControlpanelDesktopMenu />
  </>
))

HeaderMenuControlpanelContainer.propTypes = {
  eventplannerGigRequest: PropTypes.arrayOf(PropTypes.shape({})),
}
HeaderMenuControlpanelContainer.defaultProps = {
  eventplannerGigRequest: [],
}

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
)(HeaderMenuControlpanelContainer)
